<script lang="ts">
    import { sprache } from "../store"
    import { apiBaseURL as apiBaseURL_conf, baseURL } from "../config"
    import Facts from "./Facts.svelte"
    import Mediathek from "./Mediathek.svelte"
    import Karriere from "./Karriere.svelte"
    import SuchErgebnisse from "./SuchErgebnisse.svelte"
    import Teaser from "./Teaser.svelte"
    import Timeline from "./Timeline.svelte"
    import Image from "./Image.svelte"

    export let row: Row
    export let col: Col
    export let contentId: string
    export let index: number
    export let apiBaseURL: string = apiBaseURL_conf
</script>

{#if row?.title && !col.showFilter && index == 0}<h2>
        {row.title}
        {#if !row.subtitle}<div class="pulse"></div>{/if}
    </h2>
{/if}
{#if row?.subtitle && !col.showFilter && index == 0}<h3>{row.subtitle}</h3>{/if}
<div class="col {col.width}">
    {#if col.type == "teaser"}
        <section class="teaser">
            <Teaser
                buttontext="{col.buttonText}"
                buttonlink="{col.buttonLink}"
                filtertags="{col.filterTags}"
                template="{col.template}"
                sortby="{col.sortby}"
                orderby="{col.orderby}"
                limit="{col.limit}"
                showFilter="{col.showFilter}"
                title="{row.title}"
                subtitle="{row.subtitle}"
            />
        </section>
    {/if}
    {#if col.type == "text"}
        <div class="condensed">
            <section class="text">
                {@html col.text}
            </section>
        </div>
    {/if}
    {#if col.type == "timeline"}
        <div class="condensed">
            <section class="timeline">
                <Timeline items="{col.timeline}" />
            </section>
        </div>
    {/if}
    {#if col.type == "facts"}
        <div class="condensed">
            <section class="fact-list facts-{col.factType}">
                <Facts items="{col.facts}" contentId="{contentId}" />
            </section>
        </div>
    {/if}
    {#if col.type == "image"}
        <div class="condensed">
            <Image
                imageId="{col.image}"
                image_="{col.image_}"
                apiBaseURL="{apiBaseURL}"
                size="{col.imagesize}"
                showCaption
            />
        </div>
    {/if}
    {#if col.type == "map"}
        <div class="condensed">
            <section class="map">
                <iframe src="{col.mapLink}" class="{col.mapSize}" title="{row.title}"></iframe>
                {#if col.zoomLink}<a
                        href="{col.zoomLink}"
                        target="{col.zoomLinkTarget ? '_blank' : ''}"
                        class="icon zoom-in more">{col.zoomLinkName}</a
                    >{/if}
            </section>
        </div>
    {/if}
    {#if col.type == "video"}
        <div class="condensed">
            <section class="video {col.mlvideoUrl_?.external?.ratio == '4:3' ? 'ratio-4-3' : 'ratio-16-9'}">
                <db-youtube
                    class="youtube"
                    width="100%"
                    headline="Wir benötigen Ihre Zustimmung, um YouTube zu laden!"
                    description="Wenn Sie dieses Video anklicken, wird Ihnen ein externer Inhalt von YouTube (www.youtube.com) angezeigt. Welche Daten von YouTube verarbeitet werden, entzieht sich unserer Kenntnis und Einflussnahme. Weitere Informationen finden Sie in unseren <a href='/datenschutz' target='_blank'>Datenschutzhinweisen</a>."
                    src="{col.mlvideoUrl_?.external?.url?.replace('http://', 'https://')}"></db-youtube>
            </section>
            <div class="caption">
                {col.mlvideoUrl_?.title[$sprache] ? col.mlvideoUrl_.title[$sprache] : ""}{col.mlvideoUrl_?.author[
                    $sprache
                ]
                    ? " " + col.mlvideoUrl_.author[$sprache]
                    : ""}
            </div>
        </div>
    {/if}
    {#if col.type == "backbutton"}
        <div class="condensed">
            <section class="back-button">
                <div class="centered">
                    <!-- svelte-ignore a11y-click-events-have-key-events -->
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <a on:click="{() => history.back()}" class="centered border cta"
                        >{!col.backbText ? "zurück" : col.backbText}</a
                    >
                </div>
            </section>
        </div>
    {/if}
    {#if col.type == "medialibrary"}
        <Mediathek />
    {/if}
    {#if col.type == "career"}
        <Karriere />
    {/if}
    {#if col.type == "search"}
        <SuchErgebnisse />
    {/if}
</div>

<style>
    :global(section.text p) {
        margin-block-start: 1em;
        margin-block-end: 1em;
    }
</style>
